import GuiContext from "config/context/guiContext";
import { useContext, useState } from "react";
import { flushSync } from "react-dom";
import { useGetDatabaseStructureService } from "./useGetDatabaseStructureService";
import { useReadComposition } from "./useReadComposition";
import { useGetCompositionScopesService } from "./useGetCompositionScopesService";
import { useCompositionAdvancedOptionsContext } from "../context/CompositionAdvancedOptionsContext";

const initialServerStatus = {
    response: null,
    loading: false,
    error: null,
}

export const useClearComposition = () => {
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { readComposition } = useReadComposition();
    const { getCompositionScopes } = useGetCompositionScopesService();
    const { setPage, setLocalQuery, setNextKey, setPrevKey, setLocalReverse, setLocalLimit, limit } = useCompositionAdvancedOptionsContext();
    const {
        selected: { selectedAccount, selectedServer },
        URL
    } = useContext(GuiContext);

    const clearComposition = async ({ private_key, composition }) => {
        setLoading(true);
        try {
            const res = await fetch(`${URL}/api/database/clear`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    database: selectedAccount || "",
                    server_url: selectedServer || "",
                    composition: composition,
                    permission: "active",
                    private_key: private_key
                }),
            });

            const data = await res.json();
            setResponse(data);
            if (data?.status) {
                // Reset all pagination state synchronously before reading composition
                flushSync(() => {
                    setLocalQuery({});
                    setNextKey("");
                    setPrevKey("");
                    setLocalReverse(false);
                    setLocalLimit(limit || 12);
                    setPage(1);
                });
                
                getCompositionScopes({ composition });
                readComposition({ composition });
            }
            if (!data?.status) {
                setError(data?.message);
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    }

    const resetServerStatus = () => {
        setLoading(initialServerStatus.loading);
        setResponse(initialServerStatus.response);
        setError(initialServerStatus.error);
    }

    return {
        response,
        loading,
        error,
        clearComposition,
        resetServerStatus
    }
}